export const concentratorType = { //ci arrivano da be?
  "fixed": "fixed",
  "portable": "portable",
  "transportable": "transportable"
};
